import type { Patrol } from '../contracts';

export const isTest = (patrol: Patrol.Type): boolean =>
  patrol.name.toUpperCase().trim() === 'TEST' ||
  patrol.callSign?.toUpperCase().trim() === 'TEST';
